module.exports = __webpack_public_path__ + "static/img/PSN.26d83d67.png";